module.exports = __webpack_public_path__ + "img/pl.c3eca7d.svg";